import { TuiRadio } from '@taiga-ui/core';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'pxc-sadm-entity-select',
  templateUrl: './sadm-entity-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'relative block cursor-pointer rounded-xl border p-3 transition',
    '[class.border-transparent]': '!selected()',
    '[class.border-border-brand]': 'selected()',
    '[class.bg-background-primary]': 'selected()',
    '[class.shadow-xs]': 'selected()',
    '(click)': 'selectedChange.emit()',
  },
  imports: [TuiRadio],
})
export class SadmEntitySelectComponent {
  readonly selected = input<boolean>(false);
  readonly selectedChange = output<void>();
}
